/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { organizationRemoteSessionIssuersGetMigratePreflight } from "../funcs/organizationRemoteSessionIssuersGetMigratePreflight.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { OrganizationIssuerMigratePreflight } from "../models/components/organizationissuermigratepreflight.js";
import {
  GetOrganizationRemoteSessionIssuerMigratePreflightRequest,
  GetOrganizationRemoteSessionIssuerMigratePreflightSecurity,
} from "../models/operations/getorganizationremotesessionissuermigratepreflight.js";
import { unwrapAsync } from "../types/fp.js";
export type OrganizationRemoteSessionIssuerMigratePreflightQueryData =
  OrganizationIssuerMigratePreflight;

export function prefetchOrganizationRemoteSessionIssuerMigratePreflight(
  queryClient: QueryClient,
  client$: GramCore,
  request: GetOrganizationRemoteSessionIssuerMigratePreflightRequest,
  security?:
    | GetOrganizationRemoteSessionIssuerMigratePreflightSecurity
    | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildOrganizationRemoteSessionIssuerMigratePreflightQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildOrganizationRemoteSessionIssuerMigratePreflightQuery(
  client$: GramCore,
  request: GetOrganizationRemoteSessionIssuerMigratePreflightRequest,
  security?:
    | GetOrganizationRemoteSessionIssuerMigratePreflightSecurity
    | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<OrganizationRemoteSessionIssuerMigratePreflightQueryData>;
} {
  return {
    queryKey: queryKeyOrganizationRemoteSessionIssuerMigratePreflight({
      sourceId: request.sourceId,
      targetId: request.targetId,
      gramSession: request.gramSession,
      gramKey: request.gramKey,
    }),
    queryFn:
      async function organizationRemoteSessionIssuerMigratePreflightQueryFn(
        ctx,
      ): Promise<OrganizationRemoteSessionIssuerMigratePreflightQueryData> {
        const sig = combineSignals(
          ctx.signal,
          options?.signal,
          options?.fetchOptions?.signal,
        );
        const mergedOptions = {
          ...options?.fetchOptions,
          ...options,
          signal: sig,
        };

        return unwrapAsync(organizationRemoteSessionIssuersGetMigratePreflight(
          client$,
          request,
          security,
          mergedOptions,
        ));
      },
  };
}

export function queryKeyOrganizationRemoteSessionIssuerMigratePreflight(
  parameters: {
    sourceId: string;
    targetId: string;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
  },
): QueryKey {
  return [
    "@gram/client",
    "organizationRemoteSessionIssuers",
    "getMigratePreflight",
    parameters,
  ];
}
